import React, { Component } from "react";
import i18n from "@i18n/i18n";
import { StyleSheet, View } from "react-native";
import Logo from "../assets/images/Logo";

interface Props { }

interface State { }

const { t } = i18n;

export default class CustomWelcomeContent extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <View style={styles.wrapper}>
                <Logo width={200} height={80} />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: "space-between",
    },
    wrapper: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
});
